<template>
<a-table class="stripped table-hover" :columns="columns" :data-source="data" :pagination="false" :row-selection="rowSelection">
  <template #bodyCell="{ column, record }">
    <!-- <template v-if="column.key === 'Name'">
      <h2 class="table-avatar d-flex align-items-center">
        <router-link to="/crm/company-details" class="profile-split d-flex flex-column">{{ record.name }}</router-link>
      </h2>
    </template> -->
    <template v-if="column.key === 'action'">
      <div class="icon-field">
            
            <router-link :to="{ path: '/territory/create-territory', query: { territoryId: record.key}}" title="Edit" class="btn table_action_btn"><i class="ti ti-edit"></i>  Edit</router-link>
            </div>
    </template>
  </template>
</a-table>
  <!-- Fixed Pagination -->
  <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      showSizeChanger :pageSizeOptions="pageSizeOptions" @change="handleTableChange" class="d-flex" />
  </div>
</template>

<script>
import {
  useRouter
} from 'vue-router';

import apiClient from "@/axios";
import {
  message
} from "ant-design-vue";
import { computed, onMounted } from 'vue';
import { ref } from 'vue';
const columns = [{
    title: "Name",
    dataIndex: "name",
    key: "Name",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  // {
  //   title: "IP",
  //   dataIndex: "allowed_ip",
  //   key: "allowed_ip",
  //   sorter: {
  //     compare: (a, b) => {
  //       a = a.name.toLowerCase();
  //       b = b.name.toLowerCase();
  //       return a > b ? -1 : b > a ? 1 : 0;
  //     },
  //   },
  // },
  {
    title: "Created",
    dataIndex: "created",
    sorter: {
      compare: (a, b) => {
        a = a.created;
        b = b.created;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    dataIndex: "Action",
    key: "action",
    // sorter: true,
  },
];

export default {
  data() {
    return {
      columns,
      selectedUserId: null,
      showDeleteModal: false,
      // data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      rowSelection: {
        onChange: () => {},
        onSelect: () => {},
        onSelectAll: () => {},
      },
    };
  },
  // mounted() {
  //   this.fetchTerritories();
  // },
  setup() {
    const router = useRouter();
    const data= ref([])
    const pagination= ref({
        current: 1,
        pageSize: 10,
        total: 0,
      })
    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const handleTableChange = (current, pageSize) =>{
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      fetchTerritories(pagination.value.current, pagination.value.pageSize);
    }

    const fetchTerritories = async(page = 1, pageSize = 10) => {
      try {
        const token = localStorage.getItem("authToken"); // Adjust the key if necessary
        if (!token) {
          return;
        }
        const response = await apiClient.get("/territories", {
          params: {
            page,
            pageSize
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status) {
          data.value = response.data.data.data.map((territory) => ({
            key: territory.id,
            name: territory.name,
            // allowed_ip:territory.allowed_ip,
            created: formatDate(territory.created_at),
          }));
          pagination.value.total = response.data.data.total;
        } else {
          console.error("Failed to fetch territories:", response);
        }
      } catch (error) {
        console.error("Error fetching territories:", error);
      }
    }
    const formatDate = (dateTime) =>{
       return dateTime.replace(/-/g, '/');
    }

    // const openEditModal = (id) => {
    //   router.push({
    //     path: "/territory/create-territory",
    //     query: {
    //       territoryId: id
    //     }
    //   });
    // };
    onMounted(()=>{
      fetchTerritories()
    })

    return {
      // openEditModal,
      fetchTerritories,
      formatDate,
      pageSizeOptions,
      handleTableChange,
      pagination,
      data
    };
  },
  methods: {
  },
};
</script>
